if (!customElements.get('hoculus-photo-swipe')) {
    class HoculusPhotoSwipe extends HTMLElement {
        constructor() {
            super();
            this.container = this.closest(".hoculus-grid-media");
        }

        connectedCallback() {
            this.addEventListener("click", () => {
                this.initGallery();
            })
        }

        initGallery() {
            const pswpElement = document.querySelectorAll('.pswp')[0];
            this.itemsArray = document.querySelectorAll("hoculus-photo-swipe");
            const items = []
            const newArray = Array.from(this.itemsArray);
            const index = newArray.indexOf(this);
            const imageEl = this;

            for (const el of this.itemsArray) {
                const obj = {
                    src: el.dataset.mediaUrl,
                    w: el.getAttribute('data-photoswipe-width'),
                    h: el.getAttribute('data-photoswipe-height'),
                    initialZoomLevel: 0.5
                }

                items.push(obj);
            }

            const options = {
                allowPanToNext: false,
                captionEl: false,
                closeOnScroll: false,
                counterEl: false,
                history: false,
                index: index,
                showHideOpacity: true,
                pinchToClose: false,
                preloaderEl: false,
                scaleMode: 'zoom',
                shareEl: false,
                tapToToggleControls: false,
                // getThumbBoundsFn: function () {
                //     const pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
                //     const thumbnail = imageEl;
                //     const rect = thumbnail.getBoundingClientRect();
                //     return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
                // }
            }

            this.gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
            this.gallery.listen('afterChange', this.afterChange.bind(this));
            this.gallery.init();

            this.preventiOS15Scrolling();
        }

        afterChange() {
            var index = this.gallery.getCurrentIndex();
            this.container.dispatchEvent(new CustomEvent('photoswipe:afterChange', {
                detail: {
                    index: index
                }
            }));
        }

        preventiOS15Scrolling() {
            let initialScrollPos;

            if (!/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) return;

            this.syncHeight();

            // Store scroll position to restore it later
            initialScrollPos = window.scrollY;

            // Add class to root element when PhotoSwipe opens
            document.documentElement.classList.add('pswp-open-in-ios');

            window.addEventListener('resize', this.syncHeight);

            this.gallery.listen('destroy', () => {
                document.documentElement.classList.remove('pswp-open-in-ios');
                window.scrollTo(0, initialScrollPos);
            });
        }
    }
    customElements.define("hoculus-photo-swipe", HoculusPhotoSwipe);
}